import { REPORT_IS_AVAILABLE } from 'constants/actionTypes';

const initialState = false;

export default (state = initialState, action) => {
  switch (action.type) {
    case REPORT_IS_AVAILABLE:
      return action.bool || initialState;
    default:
      return state;
  }
};
